import { render } from "./App.vue?vue&type=template&id=2175e672"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2175e672&lang=scss"

import exportComponent from "/home/runner/work/prime-asia-lg-samsung/prime-asia-lg-samsung/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__